/**
 *JavaScript dependencies loading
 */
require('./scripts/global');
require('./bootstrap');

window.isLocationModalActive = false;
window.isFilterModalActive = false;